import DisclosureGuidelineModal from '@Components/Bases/DisclosureGuidelineModal';
import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, Button, Typography } from '@mui/material';

const DisclosureGuidelinesBusinessValueChains = () => {
  const [opened, { open, close }] = useDisclosure();

  return (
    <Box>
      <Button color="inherit" startIcon={<InfoPopUpIcon />} onClick={open}>
        แนวทางการเปิดเผย
      </Button>

      <DisclosureGuidelineModal
        open={opened}
        onClose={close}
        title="ห่วงโซ่คุณค่าธุรกิจ"
        description={
          <Box>
            <Typography sx={{ textIndent: 90 }}>
              ให้อธิบายลักษณะห่วงโซ่คุณค่าของธุรกิจ (value chain)
              ที่แสดงถึงความสัมพันธ์ของผู้มีส่วนได้เสียที่สำคัญในกิจกรรม
              ซึ่งเกี่ยวข้องกับการดำเนินธุรกิจตั้งแต่ต้นน้ำจนถึงปลายน้ำ
              โดยสะท้อนให้เห็นว่าบริษัทมุ่งมั่นที่จะสร้างคุณค่าให้แก่สินค้าและบริการ
              เพื่อตอบสนองความคาดหวังของผู้มีส่วนได้เสีย
              กรณีเป็นบริษัทที่ประกอบธุรกิจโดยการถือหุ้นบริษัทอื่น (holding
              company) ให้ระบุกิจกรรม ในห่วงโซ่คุณค่าของกลุ่มบริษัท
              โดยพิจารณาตามสายธุรกิจหลักที่บริษัทเห็นว่าสำคัญและเหมาะสม
            </Typography>
            <br />
            <Typography
              fontWeight="bold"
              sx={{
                textDecoration: 'underline',
                textIndent: 90,
              }}
            >
              คำแนะนำหรือคำอธิบายเพิ่มเติม
            </Typography>
            <Typography sx={{ textIndent: 90 }}>
              บริษัทสามารถเปิดเผยข้อมูลห่วงโซ่คุณค่าของธุรกิจเฉพาะภาพรวมที่ทำให้ทราบถึงความสัมพันธ์ของผู้มีส่วนได้เสียและ
              กิจกรรมต่างๆ ในการประกอบการธุรกิจ
              โดยสะท้อนให้เห็นถึงคุณค่าที่บริษัทส่งมอบให้ผู้มีส่วนได้เสียที่เกี่ยวข้องในแต่ละกิจกรรม
              ทั้งนี้ บริษัทสามารถนำเสนอ
              ข้อมูลห่วงโซ่คุณค่าของธุรกิจในรูปแบบการบรรยาย ตาราง รูปภาพ
              หรืออื่น ๆ ตามที่บริษัทเห็นว่าเหมาะสม
              ซึ่งประกอบด้วยกิจกรรมบนห่วงโซ่คุณค่า 2 ประเภท ดังนี้
            </Typography>
            <br />

            <Box>
              <Typography
                fontWeight="bold"
                sx={{
                  textIndent: 90,
                }}
              >
                1. กิจกรรมหลัก (Primary activities)
              </Typography>
              <Typography sx={{ textIndent: 105 }}>
                ให้อธิบายลักษณะของกิจกรรมหลัก ประกอบด้วยกิจกรรม 5 กิจกรรม
                ซึ่งเชื่อมโยงกันอย่างต่อเนื่องตามบริบทการดำเนินธุรกิจ
                ของบริษัทในภาพรวม ดังนี้
              </Typography>

              <Typography
                sx={{
                  textIndent: 105,
                  mt: 2,
                  textDecoration: 'underline',
                }}
              >
                (1) การบริหารปัจจัยการผลิต หรือ โลจิสติกส์ขาเข้า (Inbound
                logistics)
              </Typography>
              <Typography sx={{ textIndent: 105 }}>
                ให้สรุปข้อมูลที่เกี่ยวกับการจัดหา การนำเข้า
                และการได้มาซึ่งปัจจัยการผลิตโดยสังเขป เช่น ที่ดิน แรงงาน
                หรือทุนสำหรับ การประกอบกิจการ
                รวมถึงอธิบายลักษณะความสัมพันธ์ของคู่ค้าหรือผู้ส่งมอบวัตถุดิบ
                ทรัพยากร หรือสิ่งที่ใช้เป็นปัจจัยเพื่อการผลิตสินค้า และบริการ
                กรณีเป็นสถาบันการเงินให้อธิบายแหล่งที่มาเงินทุนและการให้กู้ยืม
              </Typography>

              <Typography
                sx={{
                  textIndent: 105,
                  mt: 2,
                  textDecoration: 'underline',
                }}
              >
                (2) การปฏิบัติการ (Operations)
              </Typography>
              <Typography sx={{ textIndent: 105 }}>
                ให้สรุปข้อมูลที่เกี่ยวกับการแปลงสภาพวัตถุดิบ ทรัพยากร
                หรือปัจจัยที่นำไปสู่การพัฒนาสินค้าที่พร้อมจำหน่าย เช่น การผลิต
                การบรรจุภัณฑ์ การตรวจสอบคุณภาพ เป็นต้น
                กรณีที่เป็นธุรกิจบริการให้อธิบายลักษณะการให้บริการ เช่น
                การให้คำปรึกษา การให้สินเชื่อ เป็นต้น
              </Typography>

              <Typography
                sx={{
                  textIndent: 105,
                  mt: 2,
                  textDecoration: 'underline',
                }}
              >
                (3) การกระจายสินค้าและบริการ หรือ โลจิสติกส์ขาออก (Outbound
                logistics)
              </Typography>
              <Typography sx={{ textIndent: 105 }}>
                ให้สรุปข้อมูลที่เกี่ยวกับกิจกรรมและช่องทางการเคลื่อนย้าย
                การกระจาย หรือการส่งมอบสินค้าและบริการ เพื่อให้ลูกค้าหรือ
                ผู้บริโภค สามารถเข้าถึงสินค้าและบริการ เช่น การขนส่ง
                การจัดจำหน่าย การจัดการคลังสินค้า
                รวมถึงการจัดการข้อมูลที่เกี่ยวข้อง
                กับการจัดเก็บและกระจายสินค้าและบริการ
              </Typography>

              <Typography
                sx={{
                  textIndent: 105,
                  mt: 2,
                  textDecoration: 'underline',
                }}
              >
                (4) การตลาดและการขาย (Marketing and Sales)
              </Typography>
              <Typography sx={{ textIndent: 105 }}>
                ให้สรุปข้อมูลที่เกี่ยวกับการตัดสินใจซื้อของลูกค้าหรือผู้บริโภค
                เช่น การกำหนดราคา การโฆษณา ประชาสัมพันธ์ โปรแกรม
                การส่งเสริมการตลาด
                พร้อมระบุช่องทางการสื่อสารข้อมูลสินค้าและบริการไปสู่ลูกค้าหรือผู้บริโภค
              </Typography>

              <Typography
                sx={{
                  textIndent: 105,
                  mt: 2,
                  textDecoration: 'underline',
                }}
              >
                (5) การบริการหลังการขาย (Customer services)
              </Typography>
              <Typography sx={{ textIndent: 105 }}>
                อธิบายกิจกรรมที่ช่วยให้บริการลูกค้าหรือผู้บริโภคเกิดความพึงพอใจภายหลังจากที่ซื้อสินค้าหรือบริการแล้ว
                โดยทั่วไป มักหมายถึงบริการหลังการขาย
              </Typography>

              <Typography
                fontWeight="bold"
                sx={{
                  textIndent: 90,
                  mt: 2,
                }}
              >
                2. กิจกรรมสนับสนุน (Support activities)
              </Typography>
              <Typography sx={{ textIndent: 105 }}>
                อธิบายลักษณะของกิจกรรมที่สนับสนุนให้กิจกรรมหลักบรรลุเป้าหมาย
                โดยสามารถอธิบายภาพรวมของกิจกรรมสนับสนุน
                พอสังเขปตามที่บริษัทเห็นว่าเหมาะสม ได้แก่ การจัดซื้อจัดหา
                (Procurement) การพัฒนาเทคโนโลยีเพื่อสินค้าและบริการ (Technology
                development) การบริหารทรัพยากรบุคคล (Human resource management)
                โครงสร้างพื้นฐาน (Infrastructure) เช่น ระบบบัญชีและการเงิน
                การบริหารจัดการองค์กร เป็นต้น
              </Typography>
            </Box>
          </Box>
        }
      />
    </Box>
  );
};

export default DisclosureGuidelinesBusinessValueChains;
